var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.inputType === "Boolean"
        ? _c(
            "b-form-checkbox",
            {
              class: _vm.inputClass,
              attrs: {
                name: "check-button",
                switch: _vm.toggle,
                disabled: _vm.disabled
              },
              on: {
                input: function($event) {
                  return _vm.input($event)
                }
              },
              model: {
                value: _vm.model,
                callback: function($$v) {
                  _vm.model = $$v
                },
                expression: "model"
              }
            },
            [
              _vm.showText
                ? _c("span", [
                    _vm._v(_vm._s(_vm.model ? _vm.textActive : _vm.textPassive))
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.inputType === "Radio"
        ? _c("b-form-radio-group", {
            attrs: { options: _vm.options, disabled: _vm.disabled },
            on: {
              input: function($event) {
                return _vm.input($event)
              }
            },
            model: {
              value: _vm.model,
              callback: function($$v) {
                _vm.model = $$v
              },
              expression: "model"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-947e8e34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-947e8e34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextCheckBox.vue
// module id = null
// module chunks = 